export default {
  title: 'Contact & Synchronization',
  labels: {
    occ_phone_number: 'Call center phone number',
    company_phone_number: 'Restaurant phone number',
    has_google_business_sync: 'Sync with Google Business',
    has_foodamigos_sync: 'Sync with Fooodamigos services',
  },
  placeholders: {
    occ_phone_number: 'Select phone number from the list',
  },
};
